// Centralised checkout configuration.
// Flutterwave webhook validates plan by plan_key, NOT by amount —
// so old $29/$99 founder-rate payments still upgrade correctly.

export const CHECKOUT = {
  pro: {
    plan_key:      "pro",
    monthly_price: 49,
    annual_price:  39,
    label:         "Professional",
    currency:      "USD",
    monthly_link:  "https://flutterwave.com/pay/vdvhoxftigdv",  // tag 161394
    annual_link:   "https://flutterwave.com/pay/c6csilpzj9ey",  // tag 161395
  },
  team: {
    plan_key:      "org",
    monthly_price: 149,
    annual_price:  119,
    label:         "Team",
    currency:      "USD",
    monthly_link:  "https://flutterwave.com/pay/d7sk1ltgg6a8",  // tag 161396
    annual_link:   "https://flutterwave.com/pay/vwraknevepzb",  // tag 161397
  },
};

// Team is now sales-led (contact info@nofodesk.com) — the team links below
// stay alive so invoiced/legacy customers can still be activated by the
// webhook (it validates plan_key, not amount).
// Founder-rate links — kept alive for early adopters on private offer paths.
// DO NOT change; webhook identifies plan by plan_key, not by amount.
export const FOUNDER = {
  pro: {
    monthly_price: 29,
    annual_price:  23,
    label:         "Founder Pro",
    monthly_link:  "https://flutterwave.com/pay/6dnskhitadbm",  // tag 161400
    annual_link:   "https://flutterwave.com/pay/36sjmwhpkdis",  // tag 161401
  },
  team: {
    monthly_price: 99,
    annual_price:  79,
    label:         "Founder Team",
    monthly_link:  "https://flutterwave.com/pay/ocn66kqe219o",  // tag 161402
    annual_link:   "https://flutterwave.com/pay/ekexsvhlnu4f",  // tag 161403
  },
};
